import React from 'react';
import { Users, CheckCircle, Clock, TrendingUp, Bot, AlertCircle, Timer, Zap, ArrowUpRight, Workflow } from 'lucide-react';
export function SimplifiedDashboard() {
  const stats = [{
    title: 'Total Patients',
    value: '2,543',
    change: '+12% from last month',
    icon: Users,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50'
  }, {
    title: 'Active Workflows',
    value: '24',
    change: '+4 new today',
    icon: Workflow,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50'
  }, {
    title: 'Automations Run',
    value: '1,284',
    change: '+16% from last week',
    icon: Bot,
    color: 'text-green-600',
    bgColor: 'bg-green-50'
  }, {
    title: 'Messages Processed',
    value: '3,782',
    change: '+6% from yesterday',
    icon: CheckCircle,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50'
  }];
  const recentRegistrations = [{
    id: 1,
    name: 'Sarah Mitchell',
    phone: '(555) 123-4567',
    email: 'sarah.mitchell@example.com',
    time: '10 mins ago',
    status: 'verified',
    handledBy: 'agent',
    processingTime: '2.8 min'
  }, {
    id: 2,
    name: 'James Cooper',
    phone: '(555) 234-5678',
    email: 'james.cooper@example.com',
    time: '25 mins ago',
    status: 'pending',
    handledBy: 'agent',
    needsReview: true,
    processingTime: '4.1 min'
  }, {
    id: 3,
    name: 'Maria Santos',
    phone: '(555) 345-6789',
    email: 'maria.santos@example.com',
    time: '1 hour ago',
    status: 'verified',
    handledBy: 'agent',
    processingTime: '3.0 min'
  }, {
    id: 4,
    name: 'Robert Chen',
    phone: '(555) 456-7890',
    email: 'robert.chen@example.com',
    time: '2 hours ago',
    status: 'pending',
    handledBy: 'agent',
    needsReview: true,
    processingTime: '3.5 min'
  }];
  return <div className="flex flex-col h-full overflow-hidden" data-id="element-2286">
      {/* Header */}
      <div className="mb-8 flex-shrink-0" data-id="element-2287">
        <h1 className="text-4xl font-bold tracking-tight mb-2" data-id="element-2288">Dashboard</h1>
        <p className="text-gray-600 text-lg" data-id="element-2289">
          Monitor your agent's performance and patient registrations
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 flex-shrink-0" data-id="element-2290">
        {stats.map((stat, index) => <div key={index} className="asika-card p-6 hover:shadow-md transition-shadow" data-id="element-2291">
            <div className="flex items-start justify-between mb-4" data-id="element-2292">
              <div className={`h-12 w-12 rounded-xl ${stat.bgColor} flex items-center justify-center`} data-id="element-2293">
                <stat.icon className={stat.color} size={24} data-id="element-2294" />
              </div>
              <ArrowUpRight size={20} className="text-gray-400" data-id="element-2295" />
            </div>
            <div className="text-3xl font-bold mb-1" data-id="element-2296">{stat.value}</div>
            <div className="text-sm text-gray-600 mb-2" data-id="element-2297">{stat.title}</div>
            <div className="text-xs text-gray-500" data-id="element-2298">{stat.change}</div>
          </div>)}
      </div>

      {/* Recent Registrations */}
      <div className="flex-1 overflow-hidden" data-id="element-2299">
        <div className="asika-card h-full flex flex-col" data-id="element-2300">
          <div className="p-6 border-b border-gray-100 flex items-center justify-between flex-shrink-0" data-id="element-2301">
            <div data-id="element-2302">
              <h2 className="text-xl font-bold" data-id="element-2303">Recent Registrations</h2>
              <p className="text-sm text-gray-600 mt-1" data-id="element-2304">
                Latest patient registrations processed by Maya
              </p>
            </div>
            <button className="text-sm font-medium text-black hover:underline flex items-center gap-1" data-id="element-2305">
              View All
              <ArrowUpRight size={16} data-id="element-2306" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-2307">
            <div className="divide-y divide-gray-100" data-id="element-2308">
              {recentRegistrations.map(registration => <div key={registration.id} className="p-6 hover:bg-gray-50 transition-colors" data-id="element-2309">
                  <div className="flex items-start justify-between" data-id="element-2310">
                    <div className="flex items-start gap-4 flex-1" data-id="element-2311">
                      <div className="h-12 w-12 rounded-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-2312">
                        {registration.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div className="flex-1" data-id="element-2313">
                        <div className="flex items-center gap-2 mb-2" data-id="element-2314">
                          <div className="font-semibold text-lg" data-id="element-2315">
                            {registration.name}
                          </div>
                          {registration.needsReview && <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800" data-id="element-2316">
                              <AlertCircle size={12} data-id="element-2317" />
                              Needs Review
                            </span>}
                          {registration.handledBy === 'agent' && !registration.needsReview && <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-2318">
                                <Bot size={12} data-id="element-2319" />
                                Agent
                              </span>}
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-2320">
                          {registration.phone}
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-2321">
                          {registration.email}
                        </div>
                        <div className="text-xs text-gray-500 mt-2" data-id="element-2322">
                          Processing time: {registration.processingTime}
                        </div>
                      </div>
                    </div>
                    <div className="text-right ml-4" data-id="element-2323">
                      <div className="text-xs text-gray-500 mb-3" data-id="element-2324">
                        {registration.time}
                      </div>
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${registration.status === 'verified' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2325">
                        {registration.status === 'verified' ? 'Verified' : 'Pending'}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}